import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  IFetchUserData,
  IListUserInviteSourcesData,
  IRequestEmailMagicLinkData,
  IRequestEmailMagicLinkInput,
  IRequestSmsMagicLinkData,
  IRequestSmsMagicLinkInput,
  ISendEmailConfirmationData,
  ISendPhoneNumberConfirmationData,
} from '@shared/models/auth';
import { USER_FRAGMENT } from '@graphql/fragments/auth.fragments';

export const FETCH_CURRENT_USER: TypedDocumentNode<IFetchUserData, {}> = gql`
  ${USER_FRAGMENT}
  query self {
    self {
      __typename
      ...UserFragment
    }
  }
`;

export const REQUEST_PASSWORD_RESET: TypedDocumentNode<
  {},
  { email: string }
> = gql`
  query requestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export const SEND_PHONE_NUMBER_CONFIRMATION: TypedDocumentNode<
  ISendPhoneNumberConfirmationData,
  {}
> = gql`
  query sendPhoneNumberConfirmation {
    sendPhoneNumberConfirmation
  }
`;

export const LIST_USER_INVITE_SOURCES: TypedDocumentNode<IListUserInviteSourcesData> = gql`
  query listUserInviteSources {
    listUserInviteSources {
      id
      name
    }
  }
`;

export const REQUEST_EMAIL_MAGIC_LINK: TypedDocumentNode<
  IRequestEmailMagicLinkData,
  IRequestEmailMagicLinkInput
> = gql`
  query requestEmailMagicLink($email: String!) {
    requestEmailMagicLink(email: $email)
  }
`;

export const REQUEST_SMS_MAGIC_LINK: TypedDocumentNode<
  IRequestSmsMagicLinkData,
  IRequestSmsMagicLinkInput
> = gql`
  query requestSmsMagicLink($phoneNumber: String!) {
    requestSmsMagicLink(phoneNumber: $phoneNumber)
  }
`;

export const SEND_EMAIL_CONFIRMATION: TypedDocumentNode<ISendEmailConfirmationData> = gql`
  query sendEmailConfirmation {
    sendEmailConfirmation
  }
`;
